// Ultrasound, Usg, Xray, Ecg ignore case

const isTextTypeReport = (testSuperGroupName) => {
    const isTextType = ["Usg", "Xray", "Ecg"].some(group => group?.toLowerCase() === testSuperGroupName?.toLowerCase());
    return isTextType;
}

export default isTextTypeReport;